export enum AuthorityStockTransfer {
  MOVIMENTATION_STOCKTRANSFER = '13.2',
}
